import i18n from '@/i18n'
i18n.mergeLocaleMessage('en', {
  "Urgent": "Urgent",
  "Serious": "Serious",
  "Normal": "Normal",
  "Unread": "Unread",
  "Read": "Read",
  "Processed": "Processed",
  "ContinuousEqualCashoutAnomalyDetectTitle": "Continuous Equal Cashout Anomaly Detection"
})
i18n.mergeLocaleMessage('zh', {
  "Urgent": "紧急",
  "Serious": "严重",
  "Normal": "正常",
  "Unread": "未读",
  "Read": "已读",
  "Processed": "已处理",
  "ContinuousEqualCashoutAnomalyDetectTitle": "连续等额提现异常识别"
})
i18n.mergeLocaleMessage('mm', {
  "Urgent": "အရေးကြီး",
  "Serious": "ပြင်းထန်",
  "Normal": "ပုံမှန်",
  "Unread": "မဖတ်ရသေး",
  "Read": "ဖတ်ပြီး",
  "Processed": "ဖြေရှင်းပြီး",
  "ContinuousEqualCashoutAnomalyDetectTitle": "ဆက်တိုက်တူညီပမာဏ ငွေထုတ်ပုံမှန်မဟုတ်မှုရှာဖွေခြင်း"
})
  